if (typeof JW === 'undefined') JW = {};
JW.TATextInput = function ($, inp, opts)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'TATEXTINPUT';
    _pri.uid = '';
    _pri.$con = null; // parent div
    _pri.$inp = null; // text input
    _pri.$lgr = null; // list group (fake select)
    _pri.$idf = null; // ID field
    _pri.$frm = null; // (parent) form
    _pri.Jtai = null; // JW.TAInp

    _pri.opts = {
        dbg_lvl: 1,
        idf: false,     // has id field
        idf2inp: false, // clear inp on idf input
        idftall: false, // trigger idf change even if id is already the same ...
        cll: null,      // object for call
        url: '',        // tah ajax url
        qps: {},        // tah additional query params
        min: 2,         // min tah query length
        mxh: 0,         // lgr max height
        exm: false,     // only accept exact matches
        exi: false,     // only set idf if exact match
        cis: false,     // case insensitive
        ppl: 'top',     // no-exact-match warn message placement
        nxtfoc: true,   // focus next input in frm
        lgr_to: ''      // CSS selector for dropdown attachment (e.g. 'body');
                        // empty = append to input's parent (default)
    };

    _pri.items_map = {};
    _pri.items_map_rev = {};
    _pri.items_map_tmp = {};
    _pri.inp_buff = '';


    _pri.extend = function()
    {
        JW.ExtCommon($, publ, _pri);
    };

    _pri.init = function(inp, opts)
    {
        _pri.uid = JW.Page.getUId();

        _pri.dbg('*** init() uid: ' + _pri.uid + ' ***');

        _pri.$inp = $(inp);
        _pri.$con = _pri.$inp.closest('div');
        _pri.$frm = _pri.$inp.closest('form');
        if (_pri.$frm.length == 0)
        {
            _pri.$frm = null;
        }

        _pri.parseData();
        _pri.parseOpts(opts);


        if (_pri.opts.url == '')
        {
            _pri.dbg('!!! init(): missing url - return!');
            return;
        }

        _pri.JtaiInit();

        _pri.lgrCreate();
        _pri.lgrInit();
        _pri.inpInit();
        _pri.evsInit();

    };

    _pri.evsInit = function()
    {

    };

    _pri.parseData = function()
    {
        let cnf = _pri.$inp.data('cnf');

        if (_pri.isObj(cnf) && $.isPlainObject(cnf))
        {
            $.each(cnf, function(k, v) {

                _pri.dbg('    cnf.k:', k, v);

                switch (k)
                {
                    case 'url':
                        _pri.opts.url = v;
                    break;

                    case 'exm':
                        _pri.opts.exm = !!v;
                    break;

                    case 'exi':
                        _pri.opts.exi = !!v;
                    break;

                    case 'cis':
                        _pri.opts.cis = !!v;
                    break;

                    case 'nxtfoc':
                        _pri.opts.nxtfoc = !!v;
                    break;

                    case 'ppl':
                        if (v != '')
                        {
                            _pri.opts.ppl = v;
                        }
                    break;

                    case 'min':
                        if (v !== '')
                        {
                            _pri.opts.min = parseInt(v);
                        }
                    break;

                    case 'mxh':
                        if (typeof v !== 'undefined')
                        {
                            let mxh = parseInt(v);
                            if (mxh > 0)
                            {
                                _pri.opts.mxh = mxh;
                            }
                        }
                    break;

                    case 'idf':
                        if (typeof v !== 'undefined' && v != '')
                        {
                            _pri.idfInit(v);
                        }
                    break;

                    case 'idf2inp':
                        _pri.opts.idf2inp = !!v;
                    break;

                    case 'idftall':
                        _pri.opts.idftall = !!v;
                    break;

                    case 'qps':
                        if (_pri.isObj(v) && $.isPlainObject(v))
                        {
                            $.each(v, function(k2, v2) {
                                _pri.opts.qps[k2] = v2;
                            });
                        }
                    break;

                    case 'cll':
                        if (_pri.isObj(v) && $.isPlainObject(v))
                        {
                            _pri.initCll(v);
                        }
                    break;

                    case 'lgr_to':
                        if (typeof v === 'string' && v != '')
                        {
                            _pri.opts.lgr_to = v;
                        }
                    break;

                    default:

                    break;
                }

            });
        }
        else
        {
            if (typeof _pri.$inp.data('url') != 'undefined')
            {
                _pri.opts.url = _pri.$inp.data('url');
            }

            if (typeof _pri.$inp.data('exm') != 'undefined' && _pri.$inp.data('exm'))
            {
                _pri.opts.exm = true;
            }

            if (typeof _pri.$inp.data('exi') != 'undefined' && _pri.$inp.data('exi'))
            {
                _pri.opts.exi = true;
            }

            if (typeof _pri.$inp.data('cis') != 'undefined' && _pri.$inp.data('cis'))
            {
                _pri.opts.cis = true;
            }

            if (typeof _pri.$inp.data('ppl') != 'undefined' && _pri.$inp.data('ppl') != '')
            {
                _pri.opts.ppl = _pri.$inp.data('ppl');
            }

            if (typeof _pri.$inp.data('min') != 'undefined' && _pri.$inp.data('min') !== '')
            {
                var min = parseInt(_pri.$inp.data('min'));
                _pri.dbg('*** min found - set to :', min);
                _pri.opts.min = min;
            }

            if (typeof _pri.$inp.data('mxh') != 'undefined')
            {
                var mxh = parseInt(_pri.$inp.data('mxh'));
                if (mxh > 0)
                {
                    _pri.opts.mxh = mxh;
                }
            }

            if (typeof _pri.$inp.data('idf') != 'undefined' && _pri.$inp.data('idf') != '')
            {
                _pri.idfInit(_pri.$inp.data('idf'));
            }

            if (typeof _pri.$inp.data('idf2inp') != 'undefined' && _pri.$inp.data('idf2inp'))
            {
                _pri.opts.idf2inp = true;
            }

            // additional query params
            if (typeof _pri.$inp.data('qps') != 'undefined' && _pri.$inp.data('qps') != '')
            {
                _pri.initQps(_pri.$inp.data('qps'));
            }

            if (typeof _pri.$inp.data('cll') === 'object')
            {
                _pri.initCll(_pri.$inp.data('cll'));
            }
        }
    };

    _pri.parseOpts = function(opts)
    {
        if (typeof opts == 'object')
        {
            for (var p in opts)
            {
                _pri.opts[p] = opts[p];
            }

            if ('idf' in opts && opts.idf != '')
            {
                _pri.idfInit(opts.idf);
            }
        }
    };

    _pri.idfInit = function(sel)
    {
        var $idf = $(sel);
        if ($idf.length > 0)
        {
            _pri.opts.idf = true;
            _pri.$idf = $idf;

            _pri.$idf.on('input', _pri.onInputIdf);
        }
        else
        {
            _pri.opts.idf = false;
            _pri.$idf = null;
        }
    };

    _pri.onInputIdf = function(e)
    {
        _pri.dbgR('*** idf on input ... opt: ', _pri.opts.idf2inp);
        if (_pri.opts.idf2inp)
        {
            _pri.$inp.val('');
        }
    };

    _pri.initQps = function(str)
    {
        var i, j, kv;
        var kvs = str.split('::');
        var len = kvs.length;
        for (i = 0; i < len; ++i)
        {
            kv = kvs[i].split(':');
            if (kv.length == 2)
            {
                _pri.opts.qps[kv[0]] = kv[1];
            }
        }
    };

    _pri.initCll = function(cll)
    {
        _pri.opts.cll = cll;
    }

    _pri.JtaiInit = function()
    {
        _pri.Jtai = JW.TAInp($, _pri.$inp, {
            url: _pri.opts.url,
            qps: _pri.opts.qps,
            min: _pri.opts.min,
            cis: _pri.opts.cis
        });

        if (_pri.opts.idf && _pri.$idf.val() != '')
        {
            _pri.Jtai.initRecord({id: _pri.$idf.val(), label: _pri.$inp.val()});
        }
    };

    _pri.lgrCreate = function()
    {
        _pri.$con.addClass('jb-txi');
        _pri.$lgr = $('<ul>').addClass('list-group anim jb-dd jb-txi');
        var $div = $('<div class="jb-dd-wrp"></div>');
        $div.append(_pri.$lgr);

        var $tgt = _pri.opts.lgr_to != '' ? $(_pri.opts.lgr_to) : null;
        if ($tgt && $tgt.length > 0)
        {
            $div.addClass('tai-mvd');   // marker for cleanup on modal close
            // propagate admin-scoped font (.admc) when moving the dropdown out of
            // its admin context, so it stays visually consistent with the input
            if (_pri.$inp.closest('.admc').length > 0)
            {
                $div.addClass('admc');
            }
            $tgt.append($div);
            _pri.$lgr.css({position: 'fixed', zIndex: 1000001});
        }
        else
        {
            _pri.$con.append($div);
        }
        _pri.$lgr.hide();
    };

    _pri.lgrInit = function()
    {
        //_pri.dbg('******** _pri.lgrInit()');
        _pri.$lgr.on('mousedown', 'li.list-group-item', function (e)
        {
            //_pri.dbg('**************** e.click()');
            e.preventDefault();
            e.stopImmediatePropagation();

            if (e.which == 1)
            {
                var $item = $(this);

                if (!$item.hasClass('disabled'))
                {
                    _pri.setItem($item);
                }
            }
            return false;
        });

        _pri.$lgr.on('mouseenter', 'li.list-group-item', function (e)
        {
            //_pri.dbg('mouseenter');
            _pri.$lgr.find('li.list-group-item.focus').removeClass('focus');
            $(this).addClass('focus');
        });
        _pri.$lgr.on('mouseleave', 'li.list-group-item', function (e)
        {
            //_pri.dbg('mouseleave');
            $(this).removeClass('focus');
        });
    };

    _pri.lgrClear = function()
    {
        _pri.$lgr.find('li').remove();
    };

    _pri.inpInit = function()
    {
        // _pri.$inp.on('click', function(e)
        // {
        //     _pri.$inp.trigger('input');
        // });

        JW.Page.on('page:clri_click', function(e, o) {

            _pri.dbgG('*** on page:clri_click', o);

            if (_pri.$inp.is(o))
            {
                _pri.dbgG('    YUPP 3, my input ...');
                // _pri.$inp.trigger('input');
                _pri.checkId();
            }
            else if (_pri.opts.idf && _pri.$idf.is(o))
            {
                _pri.dbg('    YUPP 4, my idf ...');
                _pri.onInputIdf(e);
            }
        });

        _pri.$inp.on('focus', function(e)
        {
            _pri.$inp.trigger('input');
        });

        _pri.$inp.on('blur', function(e)
        {
            _pri.dbg('*** on blur()');
            //_pri.dbg('--- focusout focs: ', $(':focus'));
            if (!_pri.$lgr.is(':focus'))
            {
                _pri.checkId();
                _pri.lgrClose();
            }
        });

        _pri.$inp.on('input', function(e)
        {
            _pri.dbg('*** $inp on input() ...');

            //_pri.dbg(_pri.$inp.data('bs.popover'));
            if (typeof _pri.$inp.data('bs.popover') != 'undefined')
            {
                _pri.$inp.popover('dispose');
            }

            var query = _pri.$inp.val();

            _pri.inp_buff = query;

            query = _pri.cleanQuery(query);

            if (query.length < _pri.opts.min)
            {
                // _pri.dbg('    query length < min', query.length, '<', _pri.opts.min);
                _pri.lgrClose();
                _pri.lgrClear();
                return false;
            }

            _pri.Jtai.onInput(query);
        });

        _pri.$inp.on('tai:response', function(e, q)
        {
            var val = _pri.$inp.val();
            var query = _pri.cleanQuery(val);
            //_pri.dbg('******** tai:response *** q: ', q, ' query: ', query);
            if (q != query)
            {
                // delayed response ...
                //_pri.dbg('!!! delayed response ...');
                return;
            }

            _pri.lgrClear();

            var arr = _pri.Jtai.getItemsList(query);
            //_pri.dbg(arr);

            $.each(arr, function(k, v)
            {
                var $new = $('<li>')
                            .addClass('list-group-item')
                            .attr('data-id', v.id)
                            .attr('data-label', v.label)
                            .html(_pri.markMatch(v.label, val));

                _pri.$lgr.append($new);
            });

            if (arr.length == 0 && _pri.$lgr.is(":visible"))
            {
                _pri.lgrClose();
            }
            else if (arr.length > 0 && _pri.$inp.is(':focus') && !_pri.$lgr.is(":visible"))
            {
                _pri.lgrOpen();
            }
        });

        _pri.$inp.on('keydown', function(e)
        {
            //_pri.dbg('*** _pri.$inp on keydown');
            var kc = e.keyCode;
            if (kc == 13)
            {
                e.preventDefault();
                _pri.lgrClose(1);
                return false;
            }
            else if (kc == 38 || kc == 40)
            {
                e.preventDefault();
                _pri.lgrKeyNav(kc);
                return false;
            }
        });
    };

    _pri.setItem = function($item)
    {
        _pri.$inp.val($item.data('label'));
        _pri.lgrClose(1);
    };

    _pri.checkId = function()
    {
        _pri.dbgG('*** checkId() _pri.opts.idf: ', _pri.opts.idf, '_pri.opts.exm: ', _pri.opts.exm);

        if (_pri.opts.idf || _pri.opts.exm)
        {
            let id_found = false;
            var id = '';
            var val = $.trim(_pri.$inp.val());
            _pri.$inp.val(val);

            if (val != '')
            {
                id = _pri.Jtai.getIdFor(val);
                _pri.dbg('*** getIdFor() returned: ', id);
                if (id == '')
                {
                    if (_pri.opts.exm)
                    {
                        _pri.noExm();
                    }
                    else
                    {
                        id = '_' + JW.Page.getUId();
                    }
                }
                else
                {
                    id_found = true;
                }
            }

            if (_pri.opts.idf)
            {
                if (id_found || !_pri.opts.exi)
                {
                    //_pri.dbg('setting id val to: ', id);
                    if (_pri.$idf.val() != id || _pri.opts.idftall)
                    {
                        _pri.$idf.val(id);
                        _pri.$idf.trigger('change');
                    }
                }
                else
                {
                    _pri.$idf.val('');
                    _pri.$idf.trigger('change');
                }
            }

            if (id_found && _pri.isObj(_pri.opts.cll))
            {
                let cllo = $.extend(true, {}, _pri.opts.cll);

                let rx = /^\{id\}$/i;
                $.each(cllo, function(k, v) {

                    _pri.dbg('    cllo.k:', k, v);

                    if (typeof v === 'string' && rx.test(v))
                    {
                        // _pri.dbgR('    found v:', v, 'set to:', id);
                        cllo[k] = id;
                    }
                    else if ($.isPlainObject(v))
                    {
                        $.each(v, function(k2, v2) {

                            _pri.dbg('    v.k2:', k2, v2);

                            if (typeof v2 === 'string' && rx.test(v2))
                            {
                                _pri.dbgR('    found v2:', v2, 'set to:', id);
                                cllo[k][k2] = id;
                            }
                            else if ($.isPlainObject(v2))
                            {
                                $.each(v2, function(k3, v3) {

                                    _pri.dbg('    v2.k3:', k3, v3);

                                    if (typeof v3 === 'string' && rx.test(v3))
                                    {
                                        _pri.dbgR('    found v3:', v3, 'set to:', id);
                                        cllo[k][k2][k3] = id;
                                    }
                                });
                            }
                        });
                    }
                });

                if (_pri.isObj(cllo._frmdt))
                {
                    $.each(cllo._frmdt, function(k, v) {

                        if (rx.test(v))
                        {
                            // _pri.dbgR('    found v:', v, 'set to:', id);
                            cllo._frmdt[k] = id;
                        }
                    });
                }

                if (typeof cllo._confirm === 'string' && cllo._confirm !== '')
                {
                    var cnfm_label = _pri.$inp.val();
                    var cnfm_email = (cnfm_label.match(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/) || [cnfm_label])[0];
                    var cnfm_msg   = cllo._confirm
                        .replace(/\{label\}/g, cnfm_label)
                        .replace(/\{email\}/g, cnfm_email)
                        .replace(/\{id\}/g, id);

                    var on_cnfm_cancel = function()
                    {
                        _pri.$inp.val('');
                        if (_pri.opts.idf)
                        {
                            _pri.$idf.val('').trigger('change');
                        }
                    };

                    if (window.JW && JW.Adm && typeof JW.Adm.confirm === 'function')
                    {
                        JW.Adm.confirm({
                            $trigger:  _pri.$inp,
                            msg:       cnfm_msg,
                            cll:       cllo,
                            plc:       'top',
                            on_cancel: on_cnfm_cancel
                        });
                        return;
                    }

                    if (!window.confirm(cnfm_msg))
                    {
                        on_cnfm_cancel();
                        return;
                    }
                }

                _pri.dbgR('    cll:', cllo);
                JW.Modal.cll(cllo);
            }
        }
    };

    _pri.noExm = function()
    {
        _pri.dbgG('*** noExm()');

        var cur_val = _pri.$inp.val();
        _pri.$inp.val('');

        // if the input lives inside a JW.Modal-mwin, anchor the popover there
        // so it inherits modal stacking + gets disposed when the modal closes
        var $mdl = _pri.$inp.closest('.mdl');
        var po_container = $mdl.length > 0 ? $mdl.get(0) : false;

        _pri.$inp.popover({
            content: '<b>"' + cur_val + '"</b> konnte nicht gefunden werden. Bitte wählen Sie einen entsprechenden Eintrag aus den Vorschlägen aus.',
            title: 'Hinweis <span class="close">&times;</span>',
            html: true,
            //placement: _pri.opts.ppl,
            placement: function(dn, te) {
                            if (JW.ViewPort.isgt('md'))
                            {
                                return _pri.opts.ppl;
                            }
                            return 'top';
                       },
            trigger: 'manual',
            container: po_container
        }).on('shown.bs.popover', function(e) {
            // _pri.dbg('on shown.bs.popover e:', e);
            // _pri.dbg('    ', _pri.$inp.data('bs.popover'));
            var $tip = $(_pri.$inp.data('bs.popover').tip);
            // _pri.dbg('    tip:', $tip);
            $tip.find('.close').on('click', function(e) {
                _pri.$inp.popover('hide');
                _pri.$inp.focus();
            });
        });
        _pri.$inp.popover("show");
    };

    _pri.lgrKeyNav = function(kc)
    {
        _pri.dbg('******** lgrKeyNav() kc: ', kc);
        var $as = _pri.$lgr.find('li.list-group-item');
        if ($as.length < 1)
        {
            return;
        }

        var $afocs = _pri.$lgr.find('li.list-group-item.focus');
        $afocs.removeClass('focus');

        var $fitem = null;

        if ($afocs.length == 0)
        {
            if (kc == 40)
            {
                $fitem = $as.first();
            }
            else
            {
                $fitem = $as.last();
            }
        }
        else
        {
            if (kc == 40)
            {
                var $nxt = $afocs.next('li.list-group-item');
                if ($nxt.length > 0)
                {
                    $fitem = $nxt;
                    //_pri.dbg('*** _pri.lgrKeyNav() next: ', $nxt);
                }
            }
            if (kc == 38)
            {
                var $prv = $afocs.prev('li.list-group-item');
                if ($prv.length > 0)
                {
                    $fitem = $prv;
                    //_pri.dbg('*** _pri.lgrKeyNav() prev: ', $prv);
                }
            }
        }

        if ($fitem != null)
        {
            $fitem.addClass('focus');
            _pri.$inp.val($fitem.text());
            _pri.$lgr.scrollTop(_pri.$lgr.scrollTop() + ($fitem.offset().top - _pri.$lgr.offset().top - _pri.$lgr.outerHeight(true) + $fitem.outerHeight(true)));
        }
        else
        {
            // fill input with original value ...
            _pri.$inp.val(_pri.inp_buff);
        }
    };

    _pri.markMatch = function(str, query)
    {
        var rx = new RegExp(RegExp.escape(query), 'i');
        return str.replace(rx, '<b>' + "$&" + '</b>');
    };

    _pri.cleanQuery = function(str)
    {
        return $.trim(str.replace(/ \|.*$/, ''));
    };

    _pri.lgrOpen = function()
    {
        _pri.$lgr.find('li.list-group-item.focus').removeClass('focus');

        _pri.$lgr.css('max-height', '');
        _pri.$lgr.css('overflow-y', '');

        // viewport-anchored mode: re-position over the input on every open
        if (_pri.opts.lgr_to != '')
        {
            var r = _pri.$inp[0].getBoundingClientRect();
            _pri.$lgr.css({top: r.bottom + 'px', left: r.left + 'px', width: r.width + 'px'});
        }

        var mxh = JW.Page.getDocHeight() - _pri.$inp.offset().top - _pri.$inp.outerHeight(true) - 20;
        if (_pri.opts.mxh > 0 && _pri.opts.mxh < mxh)
        {
            _pri.$lgr.css('max-height', _pri.opts.mxh);
            _pri.$lgr.css('overflow-y', 'auto');
        }
        else if (mxh < _pri.$lgr.outerHeight(true))
        {
            _pri.$lgr.css('max-height', mxh);
            _pri.$lgr.css('overflow-y', 'auto');
        }

        _pri.$lgr.slideDown(200, function() {
            _pri.$lgr.removeClass('anim');
            //_pri.$inp.focus();
        });
    };

    _pri.lgrClose = function(nxt)
    {
        _pri.$lgr.addClass('anim');
        _pri.$lgr.slideUp(200);
        if (typeof nxt != 'undefined')
        {
            _pri.nextInp();
        }
    };

    _pri.nextInp = function()
    {
        if (_pri.$frm != null && _pri.opts.nxtfoc)
        {
            var $inps = $(':input');
            var ix = $inps.index(_pri.$inp) + 1;
            _pri.$inp.blur();
            $inps.eq(ix).focus();
        }
        else
        {
            _pri.$inp.blur();
        }
    }

    _pri.extend();
    _pri.init(inp, opts);

    return publ;
};

//################################################################################################################################
//################################################################################################################################
//################################################################################################################################

JW.TAInp = function ($, $inp, opts)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'TAINP';
    _pri.uid = '';
    _pri.tid = '';    // tag id prefix
    _pri.opts = {
        dbg_lvl: 1,
        url: '',
        qps: {},
        min: 2
    };

    _pri.response_cache = {};
    _pri.records_map  = {};

    _pri.$inp = $inp;

    if (typeof opts == 'object')
    {
        for (var p in opts)
        {
            _pri.opts[p] = opts[p];
        }
    }

    _pri.extend = function()
    {
        JW.ExtCommon($, publ, _pri);
    };

    _pri.init = function()
    {
        if (_pri.opts.url == '')
        {
            _pri.dbg('!!! init() option url missing!');
            return false;
        }
        _pri.uid = JW.Page.getUId();
        _pri.tid = 'tai-' + _pri.uid;
    };

    publ.onInput = function(query)
    {
        // _pri.dbg('*** tai.onchange');
        if (query.length < _pri.opts.min)
        {
            // _pri.dbg('... < min ...');
            _pri.$inp.trigger('tai:response', query);
            return;
        }

        if (query in _pri.response_cache)
        {
            _pri.dbg('CACHED ...');
            //return process( _pri.response_cache[ query ] );
            _pri.$inp.trigger('tai:response', query);
            return;
        }

        var post_data = _pri.opts.qps;
        post_data.query = query;

        // _pri.dbg('    calling remote ...');

        $.ajax({
            type: "POST",
            url: _pri.opts.url,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            data: post_data,
            dataType: 'json',
            success: function (ret) {
                // _pri.dbg('*** onchange ajax.success() ...');
                //var labels = [];
                var items = [];

                $.each( ret, function (ix, obj) {
                    // _pri.dbg('    obj:', obj);
                    // _pri.dbg('    lbl: [' + obj.label + ']');
                    //labels.push(obj.label);
                    items.push(obj);
                    let lbl = obj.label;
                    if (_pri.opts.cis)
                    {
                        lbl = lbl.toLowerCase();
                    }
                    _pri.records_map[lbl] = obj.id;
                });

                _pri.response_cache[query] = items;

                //return process(labels);
                _pri.$inp.trigger('tai:response', query);
            }
        });
    };

    publ.getItemsList = function(query)
    {
        //_pri.dbg('*** TAInp.getItemsList() query: ', query);
        if ( query in _pri.response_cache )
        {
            return _pri.response_cache[query];
        }
        return [];
    }

    publ.getIdFor = function(label)
    {
        // _pri.dbg('*** TAInp.getIdFor() label: [' + label + ']');
        // _pri.dbg('    records_map: ', _pri.records_map);
        if (_pri.opts.cis)
        {
            label = label.toLowerCase();
        }
        if (label in _pri.records_map)
        {
            return _pri.records_map[label];
        }
        return '';
    }

    publ.initRecord = function(o)
    {
        // _pri.dbgG('*** TAInp.initRecord() o: ', o);
        let lbl = o.label;
        if (_pri.opts.cis)
        {
            lbl = lbl.toLowerCase();
        }
        _pri.records_map[lbl] = o.id;
    }

    _pri.extend();
    _pri.init();

    return publ;
};

//################################################################################################################################
//################################################################################################################################
//################################################################################################################################

JW.InpChcnt = function ($, inp, opts)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'INPCHCNT';
    _pri.uid = '';
    _pri.opts = {
        dbg_lvl: 1,
        nls: false,         // count nl chars ...
        prfx: 'Zeichen: '   // prefix for display
    };

    _pri.$dsp = [];
    _pri.$inp = $(inp);

    if (typeof opts == 'object')
    {
        for (var p in opts)
        {
            _pri.opts[p] = opts[p];
        }
    }

    _pri.extend = function()
    {
        JW.ExtCommon($, publ, _pri);
    };

    _pri.init = function()
    {
        _pri.uid = JW.Page.getUId();

        _pri.dbg('*** init() uid: ' + _pri.uid + ' ***');

        if (!_pri.isObj(_pri.$inp) || _pri.$inp.length == 0)
        {
            _pri.dbgR('!!! inp missing!');
            return false;
        }

        // _pri.$inp.css('border', '1px solid red');

        _pri.$dsp = _pri.$inp.parent().find('.chcnt');
        if (!_pri.isObj(_pri.$dsp) || _pri.$dsp.length == 0)
        {
            _pri.dbgR('!!! dsp missing!');
            return false;
        }

        _pri.$inp.on('input', _pri.onInput);

        _pri.onInput();
    };

    _pri.onInput = function(e)
    {
        // _pri.dbg('*** onInput()');
        let len;
        if (_pri.opts.nls)
        {
            _pri.$inp.val().length;
        }
        else
        {
            len = _pri.$inp.val().split(/\n|\r/).join('').length;
        }

        _pri.$dsp.html(_pri.opts.prfx + len);
    };

    _pri.extend();
    _pri.init();

    return publ;
};